(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-menu-panel"] && !Shopify.designMode) return;
  try {
    /* Poloha trojuhelniku: stred polozky menu relativne k panelu. Pocita se
     pri kazdem otevreni (najeti, fokus) – sirka menu se meni s oknem. */
  (() => {
    const place = (item) => {
      const panel = item.querySelector('[data-tb-menu-panel]');
      const trigger = item.querySelector('.menu-list__link');
      if (!panel || !trigger) return;
      const p = panel.getBoundingClientRect();
      const r = trigger.getBoundingClientRect();
      if (!p.width) return;
      const x = Math.min(Math.max(r.left + r.width / 2 - p.left, 24), p.width - 24);
      panel.style.setProperty('--tb-caret-x', x + 'px');
    };

    document.querySelectorAll('.menu-list__list-item').forEach((item) => {
      if (!item.querySelector('[data-tb-menu-panel]')) return;
      const update = () => requestAnimationFrame(() => place(item));
      item.addEventListener('pointerenter', update);
      item.addEventListener('focusin', update);
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
